const logError = (...data: any[]) => {
    // eslint-disable-next-line no-console
    console.log(data);
};

export default logError;
